import React, {useContext} from "react";
import { makeStyles } from "@mui/styles";
import { Button, ButtonGroup,TextField } from "@mui/material";
import { DisplayRoleContext } from '../Context_api';

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  textField: {
    width: 70,
    fontSize: 50,
    margin:0,
    borderRadius: "0px 0px 0 0"
},
btn: {
  height: 40,
}
});

interface CounterViewProps {
  initValue: number;
  identifier:number;
  handleMaterialChange:any;
  autoFocusValue: boolean;
}

export default function CounterView(props: CounterViewProps) {
  const classes = useStyles();
  const [count, setCount] = React.useState(props.initValue || 0);
  const {isDisplayOnlyRole}:any = useContext(DisplayRoleContext);

  const handleIncrement = () => {
    let countVal=count;
    countVal++;
    setCount(countVal);
    props.handleMaterialChange(countVal,props.identifier); 
  };

  const handleDecrement = () => {
    let countVal=count;
    if(countVal>-999){
    countVal--;
    setCount(countVal);
    props.handleMaterialChange(countVal,props.identifier); 
    }
  };

  const handleValueChange = (event: any) => {
    event.persist();
    const i = parseInt(event.target.name);
    let countVal=parseInt(event.target.value) || 0;;
    if(countVal>-1000){
    setCount(countVal);
    props.handleMaterialChange(countVal,i, true); 
    }
  };


  return (
    <ButtonGroup size="small" >
        <Button disabled={isDisplayOnlyRole} className= {classes.btn} onClick={handleIncrement} size="small" sx={{ mr: 0, mt:2}}>+</Button>
        <TextField disabled={isDisplayOnlyRole} value={count} autoFocus={props.autoFocusValue}  className={classes.textField} name={''+props.identifier} onChange={handleValueChange} margin="normal"  variant="outlined" size="small"></TextField>
        <Button disabled={isDisplayOnlyRole} className= {classes.btn} onClick={handleDecrement} size="small" sx={{ ml: 0, mt:2}}>-</Button>
      </ButtonGroup>
  );
}
